import React from 'react';

const TermsAndCondition = () => {
  return (
    <div
      style={{
        backgroundColor: '#1D1D1D',
        color: '#333',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        margin: '20px auto',
        maxWidth: '700px',
        textAlign: 'justify'

      }}
    >
      <h3 style={{ marginBottom: '15px', fontWeight: 'normal', color:"#fff" }}>T&C</h3>
     
      <p>Please read the terms and conditions in the FAQs section carefully before booking.</p>
    </div>
  );
};

export default TermsAndCondition;
